import React, { useState, useRef, useEffect } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { postRequest } from "../../../config/dataApi";
import { SUPPORT_CONTACT } from "../../../config/apiUrls";
import { toast } from "react-toastify";
import ConfigurationHeader from "./header";
import CountrySelect from "../../../components/CountryDropDown/CountrySelect";
import CustomInput from "../../../components/TextField/TextFeild";
import CountryCodeDropdown from "../../../components/CountryDropDown/CountryDropDown";
import parsePhoneNumberFromString from "libphonenumber-js";
import { updateUserProfile } from "../../../store/slices/authSlice";
import { FaImage, FaPlus, FaTimes } from "react-icons/fa";
import CropperModalAdmin from "../../../components/models/CropperModalAdmin";
import { ChromePicker } from "react-color";
import { adjustColorBrightness, hexToRgba, isDarkColor } from "../../../helpers/customfn";

// Formik validation schema
const validationSchema = Yup.object({
  stationSchool: Yup.string().required("Station School is required"),
  stationName: Yup.string().required("Station Name is required"),
  stationCountry: Yup.string().required("Country is required"),
  stationWebsite: Yup.string().url().required("Website is required"),
  stationEmail: Yup.string().email().required("Email is required"),
  stationPhone: Yup.string()
    .required("Phone number is required")
    .test("isValidPhone", "Invalid phone number", (value) => {
      if (!value) return false; // Required check is already handled
      const formattedValue = value.startsWith("+") ? value : `+${value}`;
      const parsedNumber = parsePhoneNumberFromString(formattedValue);
      return parsedNumber ? parsedNumber.isValid() : false;
    }),
  stationInfoPhone: Yup.string()
    .required("Phone number is required")
    .test("isValidPhone", "Invalid phone number", (value) => {
      if (!value) return false; // Required check is already handled
      const formattedValue = value.startsWith("+") ? value : `+${value}`;
      const parsedNumber = parsePhoneNumberFromString(formattedValue);
      return parsedNumber ? parsedNumber.isValid() : false;
    }),
});

const Basic = () => {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [croppedImage, setCroppedImage] = useState(user?.attributes?.stationLogo);
  const [showModal, setShowModal] = useState(false);
  const [textColor, setTextColor] = useState("#000");
  const [image, setImage] = useState(null);
  const [isHovered, setIsHovered] = useState(false);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const colorPickerRef = useRef(null);

  // Close color picker when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setShowColorPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleColorChange = (color) => {
    color = color.hex;
    const isDark = isDarkColor(color);
    const contentColor = isDark ? "#fff" : adjustColorBrightness(color, -100);
    setTextColor(contentColor);
    formik.setFieldValue("stationTheme", color);
  };

  const handleCrop = (croppedImg) => {
    console.log(croppedImg,'croppedImg')
    setCroppedImage(croppedImg);
    formik.setFieldValue("stationLogo", croppedImg);
    setShowModal(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setShowModal(true);
      };
      reader.readAsDataURL(file);
    }
  };

  const formik = useFormik({
    initialValues: {
      stationLogo: user?.attributes.stationLogo,
      stationSchool: user?.attributes.stationSchool,
      stationTheme: user?.attributes.stationTheme,
      stationName: user?.attributes.stationName,
      stationCountry: user?.attributes.stationCountry,
      stationDescription: user?.attributes.stationDescription,
      stationWebsite: user?.attributes.stationWebsite,
      stationEmail: user?.attributes.stationEmail,
      stationPhone: user?.attributes.stationPhone,
      stationInfoPhone: user?.attributes.stationInfoPhone,
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { resetForm }) => {
      
      const isForStation =  user?.attributes?.isOwner == false ? true : false ;
      console.log(values,'values')
      dispatch(
        updateUserProfile({ message: "Details Updated Successfully.", values ,isForStation})
      );
    },
  });



  return (
    <div className="section_main_div">
      <h1 className="section_heading">Configure</h1>
      <ConfigurationHeader />

      <form className="form_div" onSubmit={formik.handleSubmit}>
        <div className="form-card">
          <div className="form-elements">
            <div className="row">
              <div className="d-flex justify-content-between align-items-center">
                <div className="position-relative">
                  <div
                    className="position-relative mb-3"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                    style={{ display: 'inline-block', cursor: 'pointer' }}
                  >
                    {croppedImage ? (
                      <div style={{ position: 'relative' }}>
                        <img
                          src={croppedImage}
                          alt="Station Logo"
                          className="img-fluid"
                          style={{
                            width: "150px",
                            height: "150px",
                            objectFit: "contain",
                            border: "2px solid #ddd",
                            borderRadius: "8px",
                            backgroundColor: "#f8f9fa",
                            transition: "opacity 0.3s ease",
                            opacity: isHovered ? 0.7 : 1
                          }}
                        />
                        
                        {/* Upload icon overlay on hover */}
                        {isHovered && (
                          <div
                            className="position-absolute d-flex align-items-center justify-content-center"
                            style={{
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0,0,0,0.5)",
                              borderRadius: "8px",
                              transition: "opacity 0.3s ease"
                            }}
                          >
                            <FaImage size={32} color="white" />
                          </div>
                        )}
                      </div>
                    ) : (
                      <div
                        className="d-flex flex-column align-items-center justify-content-center"
                        style={{
                          width: "150px",
                          height: "150px",
                          backgroundColor: "#f8f9fa",
                          border: "2px dashed #ddd",
                          borderRadius: "8px",
                          transition: "all 0.3s ease",
                          opacity: isHovered ? 0.7 : 1
                        }}
                      >
                        <FaImage size={24} className="mb-2" />
                        <small className="text-muted">Upload Logo</small>
                      </div>
                    )}
                    
                    <label
                      htmlFor="profileUpload"
                      className="position-absolute"
                      style={{
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                        zIndex: 5
                      }}
                    />
                    
                    <input
                      type="file"
                      id="profileUpload"
                      accept="image/*"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                
                <div className="position-relative text-center" ref={colorPickerRef}>
                  <strong>Background Color</strong>
                  <div
                    className="d-flex align-items-center mt-2"
                    style={{
                      width: "130px",
                      height: "40px",
                      backgroundColor: formik.values.stationTheme || "#ffffff",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      cursor: "pointer"
                    }}
                    onClick={() => setShowColorPicker(!showColorPicker)}
                  />
                  <small className="d-block mt-1" style={{
                    position:"absolute",
                    bottom :"6px",
                    left:"22px",
                    fontSize:"16px",
                    color:textColor
                  }}
                  onClick={() => setShowColorPicker(!showColorPicker)}
                  >
                    {formik.values.stationTheme || "No color selected"}
                  </small>
                  
                  {showColorPicker && (
                    <div className="position-absolute" style={{ zIndex: 99, top: "70px", left: 0 }}>
                      <div className="position-relative">
                        <ChromePicker
                          color={formik.values.stationTheme}
                          onChange={handleColorChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
            <CustomInput
              label="Station Name / School Name"
              id="stationSchool"
              name="stationSchool"
              value={formik.values.stationSchool}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.stationSchool && formik.errors.stationSchool
              }
              required
            />

            <CustomInput
              label="City & State /City Letters"
              id="stationName"
              name="stationName"
              value={formik.values.stationName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.stationName && formik.errors.stationName}
              required
            />

            <div className="custom-form-group">
              <label htmlFor="stationName" className="pb-2">
                Country
              </label>
              <CountrySelect
                name="stationCountry"
                selectedCountry={formik.values.stationCountry}
                onCountryChange={(countryCode) => {
                  formik.setFieldValue("stationCountry", `${countryCode}`);
                }}
              />
              {formik.touched.stationCountry && formik.errors.stationCountry ? (
                <div className="error-text">{formik.errors.stationCountry}</div>
              ) : null}
              <hr
                className={
                  formik.touched.stationCountry && formik.errors.stationCountry
                    ? "error-hr-line"
                    : ""
                }
              />
            </div>

            <CustomInput
              label="Station Description"
              id="stationDescription"
              name="stationDescription"
              value={formik.values.stationDescription}
              onChange={(e) => {
                formik.handleChange(e);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.stationName && formik.errors.stationName}
              required
              isTextArea={true}
            />

            <CustomInput
              label="stationWebsite"
              id="stationWebsite"
              name="stationWebsite"
              value={formik.values.stationWebsite}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.stationWebsite && formik.errors.stationWebsite
              }
              required
            />
            <CustomInput
              label="stationEmail"
              id="stationEmail"
              name="stationEmail"
              value={formik.values.stationEmail}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.stationEmail && formik.errors.stationEmail}
              required
            />
            <div className="custom-form-group d-flex justify-space-between gap-2">
              <CountryCodeDropdown
                label={"Phone number for Phone icon on the flywheel"}
                phoneNumber={formik.values.stationPhone}
                onPhoneNumberChange={(countryCode) => {
                  formik.setFieldValue("stationPhone", `+${countryCode}`);
                }}
              />
              <hr
                className={
                  formik.touched.stationPhone && formik.errors.stationPhone
                    ? "error-hr-line"
                    : ""
                }
              />
              {formik.touched.stationPhone && formik.errors.stationPhone ? (
                <div className="error-text">{formik.errors.stationPhone}</div>
              ) : null}
            </div>

            <div className="custom-form-group d-flex justify-space-between">
              <CountryCodeDropdown
                label={"Phone for station info page"}
                phoneNumber={formik.values.stationInfoPhone}
                onPhoneNumberChange={(countryCode) => {
                  formik.setFieldValue("stationInfoPhone", `+${countryCode}`);
                }}
              />
              <hr
                className={
                  formik.touched.stationInfoPhone &&
                    formik.errors.stationInfoPhone
                    ? "error-hr-line"
                    : ""
                }
              />
              {formik.touched.stationInfoPhone &&
                formik.errors.stationInfoPhone ? (
                <div className="error-text">
                  {formik.errors.stationInfoPhone}
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="text-right">
          <div className="button-div">
            <button type="submit" disabled={formik.isSubmitting}>
              <span>{formik.isSubmitting ? "Sending..." : "Update"}</span>
            </button>
          </div>
        </div>
      </form>
      <CropperModalAdmin
        show={showModal}
        onClose={() => setShowModal(false)}
        image={image}
        onCrop={handleCrop}
      />
    </div>
  );
};

export default Basic;